import React from 'react'
import styled from 'styled-components'
import { useTable,useResizeColumns } from 'react-table'

import makeData from './makeData'
import {FormattedMessage} from "react-intl";


const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table({ columns, data, tableid}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
    useResizeColumns
  })
  // Render the UI for your table
  return (
    <div className="tablewrapper">
      <table {...getTableProps()} id={tableid}>
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()} >
          {headerGroup.headers.map(column => (
            <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>{column.render('Header')}</th>
          ))}
        </tr>
      ))}
      </thead>
        {/*align-content: center;*/}
      <tbody {...getTableBodyProps()} style={{alignContent : "left"}}>
      {rows.map((row, i) => {
        prepareRow(row)
        return (
          <tr {...row.getRowProps()}>
            {row.cells.map(cell => {
              if(cell.value !== "null"){
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              }else{
                return <td {...cell.getCellProps()}></td>
              }
            })}
          </tr>
        )
      })}
      </tbody>
    </table>
    </div>
  )
}

function App(props) {
  let columns;
  let arr=[];

  if(props.type === "tablespec"){
    columns = React.useMemo(
      () => [
        {
          Header: 'Database Name',
          accessor: 'db', // accessor is the "key" in the data
        },
        {
          Header: 'Table Name',
          accessor: 'table',
        },
        {
          Header: 'Persistent',
          accessor: 'persistent', // accessor is the "key" in the data
        },
        {
          Header: 'Table Alias',
          accessor: 'alias', // accessor is the "key" in the data
        }
      ],
      []
    );
    Object.keys(props.data).forEach((key)=>{
      let row = props.data[key];
      arr.push(row);
    })
  }else if(props.type === "tablemapping"){
    columns = React.useMemo(
      () => [
        {
          Header: 'Step',
          accessor: 'name', // accessor is the "key" in the data
        },
        {
          Header: 'Source Tables',
          accessor: 'srctable',
        },
        {
          Header: 'Output',
          accessor: 'output', // accessor is the "key" in the data
        },
        {
          Header: 'Join Type',
          accessor: 'jointype', // accessor is the "key" in the data
        },
        {
          Header: 'Join Condition',
          accessor: 'joincondition', // accessor is the "key" in the data
        },
        {
          Header: 'Filter',
          accessor: 'filter', // accessor is the "key" in the data
        },
        {
          Header: 'Select Rule',
          accessor: 'selectrule', // accessor is the "key" in the data
        },
        {
          Header: 'Save Mode',
          accessor: 'mode', // accessor is the "key" in the data
        },
        {
          Header: 'Order By',
          accessor: 'orderby', // accessor is the "key" in the data
        },
        {
          Header: 'Aggregation',
          accessor: 'agg', // accessor is the "key" in the data
        },
        {
          Header: 'Group by',
          accessor: 'group', // accessor is the "key" in the data
        },
        {
          Header: 'Pivot',
          accessor: 'pivot', // accessor is the "key" in the data
        },
        {
          Header: 'Scd Key',
          accessor: 'scd', // accessor is the "key" in the data
        },
        {
          Header: 'Effective Date',
          accessor: 'effective_date', // accessor is the "key" in the data
        },
        {
          Header: 'End Date',
          accessor: 'end_date', // accessor is the "key" in the data
        },
        {
          Header: 'Current Ind',
          accessor: 'current_ind', // accessor is the "key" in the data
        },
        {
          Header: 'Delete Ind',
          accessor: 'delete_ind', // accessor is the "key" in the data
        },
        {
          Header: 'Hdiff Name',
          accessor: 'hdiff', // accessor is the "key" in the data
        },
      ],
      []
    );
    Object.keys(props.data).forEach((key)=>{
      let row = props.data[key];
      arr.push(row);
    })
  }else if(props.type === "columnmapping"){
    columns = React.useMemo(
      () => [
        {
          Header: 'Source',
          accessor: 'src', // accessor is the "key" in the data
        },
        {
          Header: 'Target',
          accessor: 'tgt',
        },
        {
          Header: 'Rule Expression',
          accessor: 'rule_exp', // accessor is the "key" in the data
        },
        {
          Header: 'Step',
          accessor: 'step', // accessor is the "key" in the data
        }
      ],
      []
    );
    arr = props.data;
  }

  // const data2 = React.useMemo(() => makeData(20), [])
// console.log(props.data)


  return (
    <Styles>
      <Table columns={columns} data={arr} tableid={props.tableid}/>
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/DataPipeline/table.js